import gql from 'graphql-tag'

export const UPDATE_USER_ORGANIZATION_ROLE = gql`
  mutation updateUserOrganizationRole(
    $organizationSlug: String!
    $email: String!
    $role: UserOrganizationRole!
    $eventIds: [Int!]
    $eventTemplateIds: [Int!]
  ) {
    updateUserOrganizationRole(
      organizationSlug: $organizationSlug
      email: $email
      role: $role
      eventIds: $eventIds
      eventTemplateIds: $eventTemplateIds
    )
  }
`

export const DELETE_USER_ORGANIZATION = gql`
  mutation deleteUserOrganization($organizationSlug: String!, $email: String!) {
    deleteUserOrganization(organizationSlug: $organizationSlug, email: $email)
  }
`

export const TOGGLE_DEFAULT_ORGANIZATION = gql`
  mutation toggleDefaultOrganization($organizationSlug: String!) {
    toggleDefaultOrganization(organizationSlug: $organizationSlug)
  }
`
